import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';
import { takeUntil } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ProjectDefaultStatusType, ProjectTypeStatus, SchemaVersion } from 'src/app/Modules/management/models/instance/project-type.model';

@Component({
    selector: 'app-create-project-type-status-modal',
    templateUrl: './create-project-type-status-modal.component.html',
    styleUrls: ['./create-project-type-status-modal.component.scss'],
    standalone: false
})
export class CreateProjectTypeStatusModalComponent implements OnInit {
    @Input() modalMode: string;
    @Input() projectTypeStatusList: ProjectTypeStatus;
    @Input() defaultStatusList: ProjectTypeStatus[];

    reverseSchemaList: SchemaVersion[] = [];
    projectTypeForm: UntypedFormGroup;
    statusTypeOptionToBeSelected: string; // this is for when modal is open we can display the option already selected in the dropdown
    projectStatusType: ProjectDefaultStatusType[];
    projectStatusTypeFormControlSub: Subscription;
    colorDefault: string;
    projectTypeStatus: ProjectTypeStatus;
    ngUnsubscribe: Subject<any>;
    ZERO_INDEX = 0;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private ngbActiveModal: NgbActiveModal,
        private customToastService: CustomToastService
    ) {
        this.projectTypeStatus = new ProjectTypeStatus();
    }

    ngOnInit(): void {
        this.ngUnsubscribe = new Subject();
        // this.projectStatusType = this.instanceDataService.getActivityStatusType();

        if (this.modalMode === 'add') {
            // this.statusTypeOptionToBeSelected = this.projectStatusType[this.ZERO_INDEX].statusTypeId;
            this.createFormControls();
        } else {
            this.defaultStatusList = this.defaultStatusList.filter((item) => item.name !== this.projectTypeStatusList.name);
            this.initializeFormControls();
        }
        this.projectStatusTypeFormControlSub = this.projectTypeForm
            .get('status_type')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((statusTypeId: string) => {
                setInterval(() => {
                }, 1000);
                // let statusTypeObject = this.projectStatusType.find((item) => {
                //   return item.statusTypeId === statusTypeId;
                // });
                // this.colorDefault = statusTypeObject.colour;
            });
    }

    closeModalWithCancel() {
        this.ngbActiveModal.close(false);
        // this.reverseSchemaList = this.schemaList;
    }

    getFormControlValues() {
        this.projectTypeStatus.colour = this.colorDefault;
        this.projectTypeStatus.name = this.projectTypeForm.get('status_name').value;

        return this.projectTypeStatus;
    }

    closeModalWithResult() {
        let modalResult = this.getFormControlValues();
        if (this.checkDuplicateName()) {
            this.customToastService.errorToast('Activity Status name is already exist!', 'Duplicate Name');
        } else {
            if (this.modalMode === 'add') {
                this.ngbActiveModal.close(modalResult);
            } else {
                this.projectTypeStatusList.colour = modalResult.colour;

                this.projectTypeStatusList.name = modalResult.name;
                this.ngbActiveModal.close(this.projectTypeStatusList);
            }
        }
    }
    createFormControls() {
        this.projectTypeForm = this.formBuilder.group({
            status_name: [null, Validators.required],
            status_type: [this.statusTypeOptionToBeSelected, Validators.required],
        });
    }

    checkDuplicateName() {
        for (const projectTypeStatus of this.defaultStatusList) {
            if (
                projectTypeStatus.name.toLocaleLowerCase().replace(/ /g, '') ===
                this.projectTypeForm.get('status_name').value.toLocaleLowerCase().replace(/ /g, '')
            ) {
                return true;
            }
        }
    }

    initializeFormControls() {
        // this.projectTypeForm = this.formBuilder.group({
        //   status_name: [this.projectTypeStatusList.name, Validators.required],
        //   status_type: [
        //     this.projectTypeStatusList.statusType.statusTypeId,
        //     Validators.required,
        //   ],
        // });
        // this.colorDefault = this.projectTypeStatusList.colour;
    }
}
